import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const serviceItems = [
  { icon: 'ri-t-shirt-line', titleKey: 'services.dtf.title', descKey: 'services.dtf.desc', badgeKey: 'services.dtf.badge' },
  { icon: 'ri-cup-line', titleKey: 'services.sub.title', descKey: 'services.sub.desc', badgeKey: 'services.sub.badge' },
  { icon: 'ri-printer-line', titleKey: 'services.com.title', descKey: 'services.com.desc', badgeKey: 'services.com.badge' },
  { icon: 'ri-car-line', titleKey: 'services.micro.title', descKey: 'services.micro.desc', badgeKey: 'services.micro.badge' },
];

const ServicesSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white" id="servicios">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest">{t('services.tag')}</span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0A1628] mt-3 mb-4">{t('services.title')}</h2>
          <p className="text-[#6C757D] text-lg max-w-2xl mx-auto">{t('services.subtitle')}</p>
          <div className="w-16 h-1 bg-[#FF6B35] rounded-full mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {serviceItems.map((service) => (
            <div
              key={service.titleKey}
              className="group bg-white border border-[#E5E5E5] rounded-2xl p-6 md:p-8 flex flex-col hover:border-[#FF6B35]/40 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#0A1628] rounded-xl mb-6 group-hover:bg-[#FF6B35] transition-colors duration-300">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              <span className="inline-block bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-semibold px-3 py-1 rounded-full mb-3 w-fit">
                {t(service.badgeKey)}
              </span>
              <h3 className="text-[#0A1628] font-bold text-xl mb-3">{t(service.titleKey)}</h3>
              <p className="text-[#6C757D] text-sm leading-relaxed flex-1">{t(service.descKey)}</p>
              <Link
                to="/servicios"
                className="inline-flex items-center gap-2 text-[#FF6B35] text-sm font-semibold mt-6 cursor-pointer hover:gap-3 transition-all whitespace-nowrap"
              >
                {t('services.cta')}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
